import { ICONS } from '@thinknet-gmbh/platform-common-ui';
import { PlatformModulesEnum } from '@thinknet-gmbh/platform-common';

import { ROUTES } from 'src/components/app/app-routes.constants';

export const SIDEBAR_CONFIG = {
  module: PlatformModulesEnum.PLAN_WERK_MODULE,
  menuItems: [
    { title: 'dashboard', icon: ICONS.homeAlt, path: ROUTES.dashboard },
    { title: 'gantt', icon: ICONS.layout, path: ROUTES.gantt },
    { title: 'project', icon: ICONS.spreadsheet, path: ROUTES.project },
    { title: 'employee', icon: ICONS.briefcase, path: ROUTES.employee },
    {
      title: 'customer',
      icon: ICONS.happy,
      path: ROUTES.customers,
    },
  ],
  menuItemsPrimary: [{ title: 'settings', icon: ICONS.cog, path: ROUTES.settings }],
};
